import { customerApi } from "../../utils/apiConfig";

export const getScadaHealth = () => {
  return customerApi.get(`/getScadaHealth`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getAnlikHizlar = () => {
  return customerApi.get(`/getAnlikHizlar`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getGrafikVerileri = (params = {}) => {
  return customerApi.get(`/getGrafikVerileri`, {
    params,
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getScadaVeriler = (params = {}) => {
  return customerApi.get(`/getScadaVeriler`, {
    params,
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};